import { 
	GetAssessmentActionsTypes,
	GetAssessmentsActionsTypes,
	CreateAssessmentActionsTypes, CreateAssessmentModel,
	UpdateAssessmentActionsTypes, UpdateAssessmentModel,
	DeleteAssessmentActionsTypes
} from './types';

export const getAssessmentRequest  = () => (
	{
		type: GetAssessmentActionsTypes.GET_ASSESSMENT,
	}
);

export const getAssessmentsRequest  = () => (
	{
		type: GetAssessmentsActionsTypes.GET_ASSESSMENTS,		
	}
);

export const createAssessmentRequest  = (model: CreateAssessmentModel) => (
	{
		type: CreateAssessmentActionsTypes.POST_CREATE_ASSESSMENT,
		model		
	}
);

export const updateAssessmentRequest  = (id: number, model: UpdateAssessmentModel) => (
	{
		type: UpdateAssessmentActionsTypes.PUT_UPDATE_ASSESSMENT,
		id,
		model		
	}
);

export const deleteAssessmentRequest  = (id: number) => (
	{
		type: DeleteAssessmentActionsTypes.DELETE_ASSESSMENT,
		id	
	}
);
